import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import SearchHeader from './components/SearchHeader';
import SavedSearchPresets from './components/SavedSearchPresets';
import StatsBar from './components/StatsBar';
import ClientDataGrid from './components/ClientDataGrid';
import BulkActionsBar from './components/BulkActionsBar';
import PaginationControls from './components/PaginationControls';
import AdvancedSearchModal from './components/AdvancedSearchModal';
import ExportModal from './components/ExportModal';

const ClientSearchAndDirectory = () => {
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [locationFilter, setLocationFilter] = useState('all');
  const [dateRangeStart, setDateRangeStart] = useState('');
  const [dateRangeEnd, setDateRangeEnd] = useState('');
  const [selectedClients, setSelectedClients] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [sortColumn, setSortColumn] = useState('clientId');
  const [sortDirection, setSortDirection] = useState('asc');
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);

  const mockClients = [
    {
      id: 1,
      clientId: "BA-2025-001234",
      fullName: "Anna Schmidt",
      birthDate: "1985-03-15",
      status: "Aktiv",
      lastContact: "2025-11-20",
      caseWorker: "Dr. Michael Weber",
      location: "Berlin",
      occupation: "Softwareentwicklerin"
    },
    {
      id: 2,
      clientId: "BA-2025-001235",
      fullName: "Thomas Müller",
      birthDate: "1978-07-22",
      status: "Ausstehend",
      lastContact: "2025-11-18",
      caseWorker: "Sarah Fischer",
      location: "München",
      occupation: "Projektmanager"
    },
    {
      id: 3,
      clientId: "BA-2025-001236",
      fullName: "Maria Wagner",
      birthDate: "1992-11-08",
      status: "Aktiv",
      lastContact: "2025-11-25",
      caseWorker: "Dr. Michael Weber",
      location: "Hamburg",
      occupation: "Grafikdesignerin"
    },
    {
      id: 4,
      clientId: "BA-2025-001237",
      fullName: "Klaus Becker",
      birthDate: "1965-05-30",
      status: "Inaktiv",
      lastContact: "2025-10-15",
      caseWorker: "Julia Hoffmann",
      location: "Köln",
      occupation: "Buchhalter"
    },
    {
      id: 5,
      clientId: "BA-2025-001238",
      fullName: "Sophie Schneider",
      birthDate: "1988-09-12",
      status: "Aktiv",
      lastContact: "2025-11-24",
      caseWorker: "Sarah Fischer",
      location: "Frankfurt",
      occupation: "Marketingmanagerin"
    },
    {
      id: 6,
      clientId: "BA-2025-001239",
      fullName: "Michael Hoffmann",
      birthDate: "1995-02-18",
      status: "Ausstehend",
      lastContact: "2025-11-22",
      caseWorker: "Dr. Michael Weber",
      location: "Stuttgart",
      occupation: "Mechaniker"
    },
    {
      id: 7,
      clientId: "BA-2025-001240",
      fullName: "Laura Zimmermann",
      birthDate: "1983-12-05",
      status: "Aktiv",
      lastContact: "2025-11-26",
      caseWorker: "Julia Hoffmann",
      location: "Düsseldorf",
      occupation: "Lehrerin"
    },
    {
      id: 8,
      clientId: "BA-2025-001241",
      fullName: "Stefan Koch",
      birthDate: "1970-08-25",
      status: "Archiviert",
      lastContact: "2025-09-10",
      caseWorker: "Sarah Fischer",
      location: "Dortmund",
      occupation: "Elektriker"
    },
    {
      id: 9,
      clientId: "BA-2025-001242",
      fullName: "Julia Richter",
      birthDate: "1990-04-14",
      status: "Aktiv",
      lastContact: "2025-11-23",
      caseWorker: "Dr. Michael Weber",
      location: "Berlin",
      occupation: "Krankenschwester"
    },
    {
      id: 10,
      clientId: "BA-2025-001243",
      fullName: "Andreas Meyer",
      birthDate: "1987-06-20",
      status: "Aktiv",
      lastContact: "2025-11-21",
      caseWorker: "Julia Hoffmann",
      location: "München",
      occupation: "Architekt"
    },
    {
      id: 11,
      clientId: "BA-2025-001244",
      fullName: "Christina Braun",
      birthDate: "1993-10-03",
      status: "Ausstehend",
      lastContact: "2025-11-19",
      caseWorker: "Sarah Fischer",
      location: "Hamburg",
      occupation: "Rechtsanwältin"
    },
    {
      id: 12,
      clientId: "BA-2025-001245",
      fullName: "Daniel Schulz",
      birthDate: "1982-01-28",
      status: "Aktiv",
      lastContact: "2025-11-25",
      caseWorker: "Dr. Michael Weber",
      location: "Köln",
      occupation: "Ingenieur"
    },
    {
      id: 13,
      clientId: "BA-2025-001246",
      fullName: "Petra Lange",
      birthDate: "1975-07-16",
      status: "Inaktiv",
      lastContact: "2025-10-28",
      caseWorker: "Julia Hoffmann",
      location: "Frankfurt",
      occupation: "Verkäuferin"
    },
    {
      id: 14,
      clientId: "BA-2025-001247",
      fullName: "Martin Krause",
      birthDate: "1989-03-09",
      status: "Aktiv",
      lastContact: "2025-11-24",
      caseWorker: "Sarah Fischer",
      location: "Stuttgart",
      occupation: "Koch"
    },
    {
      id: 15,
      clientId: "BA-2025-001248",
      fullName: "Sandra Wolf",
      birthDate: "1991-11-22",
      status: "Aktiv",
      lastContact: "2025-11-26",
      caseWorker: "Dr. Michael Weber",
      location: "Düsseldorf",
      occupation: "Physiotherapeutin"
    },
    {
      id: 16,
      clientId: "BA-2025-001249",
      fullName: "Oliver Schröder",
      birthDate: "1986-05-07",
      status: "Ausstehend",
      lastContact: "2025-11-20",
      caseWorker: "Julia Hoffmann",
      location: "Dortmund",
      occupation: "Bankkaufmann"
    },
    {
      id: 17,
      clientId: "BA-2025-001250",
      fullName: "Sabine Klein",
      birthDate: "1994-08-31",
      status: "Aktiv",
      lastContact: "2025-11-23",
      caseWorker: "Sarah Fischer",
      location: "Berlin",
      occupation: "Journalistin"
    },
    {
      id: 18,
      clientId: "BA-2025-001251",
      fullName: "Frank Werner",
      birthDate: "1972-12-19",
      status: "Archiviert",
      lastContact: "2025-08-15",
      caseWorker: "Dr. Michael Weber",
      location: "München",
      occupation: "Tischler"
    },
    {
      id: 19,
      clientId: "BA-2025-001252",
      fullName: "Monika Schwarz",
      birthDate: "1984-02-26",
      status: "Aktiv",
      lastContact: "2025-11-22",
      caseWorker: "Julia Hoffmann",
      location: "Hamburg",
      occupation: "Apothekerin"
    },
    {
      id: 20,
      clientId: "BA-2025-001253",
      fullName: "Jürgen Zimmermann",
      birthDate: "1968-09-14",
      status: "Inaktiv",
      lastContact: "2025-11-01",
      caseWorker: "Sarah Fischer",
      location: "Köln",
      occupation: "Fahrer"
    },
    {
      id: 21,
      clientId: "BA-2025-001254",
      fullName: "Karin Hartmann",
      birthDate: "1996-06-11",
      status: "Aktiv",
      lastContact: "2025-11-25",
      caseWorker: "Dr. Michael Weber",
      location: "Frankfurt",
      occupation: "Webdesignerin"
    },
    {
      id: 22,
      clientId: "BA-2025-001255",
      fullName: "Ralf Neumann",
      birthDate: "1981-04-23",
      status: "Ausstehend",
      lastContact: "2025-11-21",
      caseWorker: "Julia Hoffmann",
      location: "Stuttgart",
      occupation: "Versicherungskaufmann"
    },
    {
      id: 23,
      clientId: "BA-2025-001256",
      fullName: "Birgit Lehmann",
      birthDate: "1977-10-08",
      status: "Aktiv",
      lastContact: "2025-11-24",
      caseWorker: "Sarah Fischer",
      location: "Düsseldorf",
      occupation: "Friseurin"
    },
    {
      id: 24,
      clientId: "BA-2025-001257",
      fullName: "Markus Vogel",
      birthDate: "1992-01-17",
      status: "Aktiv",
      lastContact: "2025-11-26",
      caseWorker: "Dr. Michael Weber",
      location: "Dortmund",
      occupation: "IT-Consultant"
    },
    {
      id: 25,
      clientId: "BA-2025-001258",
      fullName: "Ute Bauer",
      birthDate: "1985-07-29",
      status: "Aktiv",
      lastContact: "2025-11-23",
      caseWorker: "Julia Hoffmann",
      location: "Berlin",
      occupation: "Sozialarbeiterin"
    }
  ];

  const savedPresets = [
    { id: 1, name: "Aktive Klienten Berlin", filters: { status: 'active', location: 'berlin' } },
    { id: 2, name: "Ausstehende Fälle", filters: { status: 'pending' } },
    { id: 3, name: "Letzte 30 Tage", filters: { dateRange: 30 } }
  ];

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  const handleSelectClient = (clientId, checked) => {
    if (checked) {
      setSelectedClients([...selectedClients, clientId]);
    } else {
      setSelectedClients(selectedClients?.filter(id => id !== clientId));
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedClients(mockClients?.map(client => client?.id));
    } else {
      setSelectedClients([]);
    }
  };

  const handleClientClick = (client) => {
    navigate('/client-profile-management', { state: { clientId: client?.clientId } });
  };

  const handleSearch = () => {
    // Search logic would go here
    console.log('Searching with filters:', { searchQuery, statusFilter, locationFilter, dateRangeStart, dateRangeEnd });
  };

  const handleReset = () => {
    setSearchQuery('');
    setStatusFilter('all');
    setLocationFilter('all');
    setDateRangeStart('');
    setDateRangeEnd('');
  };

  const handleLoadPreset = (preset) => {
    // Load preset logic
    console.log('Loading preset:', preset);
  };

  const handleDeletePreset = (presetId) => {
    // Delete preset logic
    console.log('Deleting preset:', presetId);
  };

  const handleAdvancedSearch = (queryBuilder) => {
    // Advanced search logic
    console.log('Advanced search:', queryBuilder);
  };

  const totalRecords = mockClients?.length;
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentClients = mockClients?.slice(startIndex, endIndex);

  const activeClientsCount = mockClients?.filter(c => c?.status === 'Aktiv')?.length;
  const pendingClientsCount = mockClients?.filter(c => c?.status === 'Ausstehend')?.length;

  return (
    <div className="min-h-screen bg-background">
      <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
      <Header sidebarCollapsed={sidebarCollapsed} />
      <main className={`main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <SearchHeader
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          locationFilter={locationFilter}
          setLocationFilter={setLocationFilter}
          dateRangeStart={dateRangeStart}
          setDateRangeStart={setDateRangeStart}
          dateRangeEnd={dateRangeEnd}
          setDateRangeEnd={setDateRangeEnd}
          onSearch={handleSearch}
          onReset={handleReset}
          onAdvancedSearch={() => setShowAdvancedSearch(true)}
          onSavePreset={() => console.log('Save preset')}
        />

        <SavedSearchPresets
          presets={savedPresets}
          onLoadPreset={handleLoadPreset}
          onDeletePreset={handleDeletePreset}
        />

        <StatsBar
          totalClients={totalRecords}
          activeClients={activeClientsCount}
          pendingClients={pendingClientsCount}
          lastSync="26.11.2025 19:04"
        />

        <div className="p-6">
          <ClientDataGrid
            clients={currentClients}
            selectedClients={selectedClients}
            onSelectClient={handleSelectClient}
            onSelectAll={handleSelectAll}
            onSort={handleSort}
            sortColumn={sortColumn}
            sortDirection={sortDirection}
            onClientClick={handleClientClick}
          />

          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            pageSize={pageSize}
            totalRecords={totalRecords}
            onPageChange={setCurrentPage}
            onPageSizeChange={(newSize) => {
              setPageSize(newSize);
              setCurrentPage(1);
            }}
          />
        </div>

        <BulkActionsBar
          selectedCount={selectedClients?.length}
          onUpdateStatus={() => console.log('Update status')}
          onReassignWorker={() => console.log('Reassign worker')}
          onGenerateDocuments={() => console.log('Generate documents')}
          onExport={() => setShowExportModal(true)}
          onClearSelection={() => setSelectedClients([])}
        />

        <AdvancedSearchModal
          isOpen={showAdvancedSearch}
          onClose={() => setShowAdvancedSearch(false)}
          onSearch={handleAdvancedSearch}
        />

        <ExportModal
          isOpen={showExportModal}
          onClose={() => setShowExportModal(false)}
          selectedCount={selectedClients?.length}
        />
      </main>
    </div>
  );
};

export default ClientSearchAndDirectory;